<div class="dashboard-header-container">
	<div class="header-left">
		<div class="report-info">
			<h2 class="report-title">Drilling KPI</h2>
			<p class="report-subtitle">
				<span class="subtitle-span">{{ activeTabTitle }}</span> - {{ activeTabDescription ?? 'visualizes Total drilled holes, length & time, Average time ' }}
				<span class="laptop-br"><br></span>
				{{ 'between holes, time per hole & drilled holes per day' }}
			</p>
		</div>
	</div>

	<div class="header-right">
		<div class="custom-dropdown" [class.open]="drillDropdownOpen" (click)="toggleDrillDropdown()">
			<div class="selected-option">
				{{ drillingControl.value?.name || 'Select Drill' }}
				<span *ngIf="drillingControl.value" class="clear-icon" (click)="clearDrillSelection($event)">✖</span>
				<span *ngIf="!drillingControl.value" class="arrow">&#9662;</span>
			</div>

			<ul class="options-list" *ngIf="drillDropdownOpen">
				<li *ngFor="let option of drillingDataOptions"
					[class.selected]="drillingControl.value?.uuid === option.uuid"
					(click)="onDrillOptionSelected(option, $event)">
				{{ option.name }}
				</li>
			</ul>
		</div>

		<div class="export-btn">
			<button mat-button class="export-pdf-btn primary cta"
				*ngIf="activeTabTitle !== 'Utilization Table View'" (click)="pdfDownload()">
				<mat-icon class="svg-icon" svgIcon="pdfIcon"></mat-icon>Export as PDF
			</button>

			<button mat-button class="export-pdf-btn primary cta"
				*ngIf="activeTabTitle === 'Utilization Table View'" (click)="utilizationTableRef?.addUtilizationValues()"
				[disabled]="!utilizationTableRef.siteId || utilizationTableRef.tableLoading">
				<mat-icon class="svg-icon" svgIcon="addIcon"></mat-icon>Add Goal
			</button>
		</div>
	</div>
</div>

<mat-tab-group (selectedTabChange)="onSequenceChangeEvent($event)">
	<mat-tab label="Fielder Analytics">
		<ng-template matTabContent>
			<app-fielder-analytics></app-fielder-analytics>
		</ng-template>
	</mat-tab>

	<mat-tab label="Holes & Drilled Holes">
		<ng-template matTabContent>
			<app-holes-n-drilled-holes></app-holes-n-drilled-holes>
		</ng-template>
	</mat-tab>
	<mat-tab label="Drilled Holes by Drilled Length">
		<ng-template matTabContent>
			<app-drilled-holes-by-drilled-length></app-drilled-holes-by-drilled-length>
		</ng-template>
	</mat-tab>
	<mat-tab label="Utilization on Shot">
		<ng-template matTabContent>
			<app-utilization-on-shot></app-utilization-on-shot>
		</ng-template>
	</mat-tab>
	<mat-tab label="Fielder Analytics by Drill">
		<ng-template matTabContent>
			<app-fielder-analytics-by-drill></app-fielder-analytics-by-drill>
		</ng-template>
	</mat-tab>
	<mat-tab label="Utilization Table View">
		<ng-template matTabContent>
			<app-utilization-table-view #utilizationTableView></app-utilization-table-view>
		</ng-template>
	</mat-tab>
</mat-tab-group>